import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

type FeeLike = {
  readonly name?: string | null;
  readonly totalCents?: number | null;
};

type CartLike = {
  readonly fees?: ReadonlyArray<FeeLike | null> | null;
  readonly subTotalCents?: number | null;
  readonly taxCents?: number | null;
  readonly totalCents?: number | null;
};

export const useCartWithServerOrderSurcharges = <Cart extends CartLike | null | undefined>(
  cart: Cart
) => {
  const enablePosOrderSurchargesAsFees = Boolean(
    useFlag(LaunchDarklyFlag.ENABLE_POS_ORDER_SURCHARGES_AS_FEES)
  );

  return {
    cart,
    cartTotalCents: cart?.totalCents ?? 0,
    enablePosOrderSurchargesAsFees,
  };
};
